import { TableField, defaultDateTimeFormatter } from "../../table-field";

export const fieldsParticipanteLicitacao: TableField[] = [
  {
    key: "TldParticipante",
    label: "País",
    tdClass: "align-middle",
    thClass: "text-center",
    sortable: true,
  },
  {
    key: "CdCpfCnpjParticipante",
    label: "CPF/CNPJ/Doc.",
    tdClass: "align-middle",
    thClass: "text-center",
    sortable: true,
  },
  {
    key: "NmParticipante",
    label: "Nome",
    tdClass: "align-middle",
    thClass: "text-center",
    sortable: true,
  },
];

export const fieldEdicaoParticipanteLicitacao: TableField = {
  key: "actions",
  label: "Ações",
  tdClass: ["align-middle", "col-actions"],
  thClass: "text-center",
  sortable: false,
};
